<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            lịch sử</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Sản phẩm:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-select placeholder="Chọn trạng thái" v-model="search.nMaSanPham">
                  <el-option label="Tất cả" value=""></el-option>
                  <el-option v-for="item in listProduct" :label="item.odooName"
                    :value="item.nMaSanPham.toString()"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Lý do:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-select placeholder="Chọn lý do" v-model="search.nLyDo">
                  <el-option label="Tất cả" value=""></el-option>
                  <el-option label="Nhập hàng" value="1"></el-option>
                  <el-option label="Xuất hàng" value="2"></el-option>
                  <el-option label="Bán hàng" value="3"></el-option>
                  <el-option label="Trả hàng" value="4"></el-option>
                  <el-option label="Thêm mới" value="5"></el-option>
                  <el-option label="Chỉnh sửa" value="6"></el-option>
                  <el-option label="Xóa" value="7"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Thời gian:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-date-picker  format="DD/MM/YYYY" v-model="search.createDate" type="daterange"
                  range-separator="-" start-placeholder="Từ ngày" end-placeholder="đến ngày" style="width: 100%" />
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="findPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
      </div>

      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" fit stripe
            highlight-current-row v-loading="isLoading">
            <el-table-column prop="dNgayTao" label="Thời gian" width="150" align="center">
              <template #default="scope">
                <span v-if="scope.row.dNgayTao">{{ moment(scope.row.dNgayTao).format("HH:mm - DD/MM/YYYY") }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="odooName" label="Sản phẩm">
              <template #default="scope">
                <div style="display: flex; gap: 10px">
                  <el-image style="width: 50px; height: 50px" :src="baseUrl + '/product/img/' + scope.row.odooImage1920"
                    :fit="'fill'" />
                  <span>{{ scope.row.odooName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Lý do" width="150" align="center">
              <template #default="scope">
                <span v-if="scope.row.nLyDo === 1">Nhập hàng</span>
                <span v-else-if="scope.row.nLyDo === 2">Xuất hàng</span>
                <span v-else-if="scope.row.nLyDo === 3">Bán hàng</span>
                <span v-else-if="scope.row.nLyDo === 4">Trả hàng</span>
                <span v-else-if="scope.row.nLyDo === 5">Thêm mới</span>
                <span v-else-if="scope.row.nLyDo === 6">Chỉnh sửa</span>
                <span v-else-if="scope.row.nLyDo === 7">Xóa</span>
              </template>
            </el-table-column>
            <el-table-column label="Số lượng" width="100" align="center">
              <template #default="scope">
                <span v-if="scope.row.nSoLuong > 0" style="color: green">+{{ scope.row.nSoLuong }}</span>
                <span v-else style="color: red">{{ scope.row.nSoLuong }}</span>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>

      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize" />
      </div>
    </div>
  </div>
</template>
<script>
import { Inventory, Product } from "@/store/enums/StoreEnums";
import { baseUrl } from "@/utils/global"
import moment from "moment";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
export default {
  data() {
    return {
      store: useStore(),
      baseUrl: baseUrl,
      pageRequest: { pageNum: 1, pageSize: 30 },
      isLoading: false,
      tableData: [],
      search: {
        createDate: [],
        nLyDo: "",
        nMaSanPham: "",
      },
      listProduct: []
    }
  },
  methods: {
    async findPage() {
      let fromDate = ""
      let toDate = ""

      if (this.search.createDate && this.search.createDate.length === 2) {
        fromDate = moment(this.search.createDate[0]).format("DD/MM/YYYY")
        toDate = moment(this.search.createDate[1]).format("DD/MM/YYYY")
      }
      this.pageRequest.columnFilters = {
        fromDate: { value: fromDate },
        toDate: { value: toDate },
        nLyDo: { value: this.search.nLyDo },
        nMaSanPham: { value: this.search.nMaSanPham }
      }

      const res = await this.store.dispatch(Inventory.getHistorys, this.pageRequest)
      if (res.code === 200) {
        this.tableData = res.data
      }
    },
    handleSizeChange(val) {
      this.pageRequest.pageSize = val
      this.findPage()
    },

    handleCurrentChange(val) {
      this.pageRequest.pageNum = val
      this.findPage()
    },

    async getListProduct() {
      const res = await this.store.dispatch(Product.showProduct)
      if (res.code === 200)
        this.listProduct = res.data
    }
  },
  mounted() {
    this.findPage()
    this.getListProduct()
  },
}

</script>
